import {
  CTA,
  styled,
  Text,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, {useContext} from 'react';
import {PagesContext} from '../../store/context/modules/PagesContext';
import {PAGES} from '../../types/enums/pages.enum';
import {Vehicle} from '../../types/vehicles';
import {useAppDispatch} from '../../store/hooks';
import {set} from '../../store/slice/vehicle';
import useTrans from '../../hooks/use-trans';
import {
  TrackingContext,
  TrackingEvents,
} from '../../store/context/modules/TrackingContext';
import { AppContext } from '../../store/context/AppContext';

type VehicleInterface = {
  vehicle: Vehicle;
};

const VehicleContainer = styled.div`
  margin-bottom: 1rem;
  display: grid;
  grid-template-rows: 80px 120px 10px 50px;
  grid-template-columns: 1fr 150px 1fr;
  grid-template-areas:
    'bg     bg      bg'
    'title  title   title'
    'car    car     car'
    '.      select  .';
`;

const BackgroundContainer = styled.div<{background?: string}>`
  height: 150px;
  background-color: ${(props) =>
    props.background ? props.background : '#A48100'};
  grid-area: bg-start / car-start / car-end / bg-end;
  z-index: 0;
`;

const TitleContainer = styled.div<{fontColor?: string}>`
  color: ${(props) => (props.fontColor ? props.fontColor : '#FFF')};
  grid-area: bg-start / title-start / bg-end / title-end;
  z-index: 1;
  margin: 1rem;
`;

const ImageContainer = styled.div`
  grid-area: title-start / car-start / title-end / car-end;
  z-index: 1;
  width: 100%;
  max-width: 350px;
  align-self: end;

  img {
    width: 90%;
    margin: 0 auto;
    display: flex;
  }
`;

const CTAContainer = styled.div`
  margin-top: 0.5rem;
  grid-area: car-end / select-start / select-end / select-end;
  width: 150px;
`;

const VehicleComponent: React.FC<VehicleInterface> = ({vehicle}) => {
  const appCtx = useContext(AppContext);
  const pageCtx = useContext(PagesContext);
  const trackCtx = useContext(TrackingContext);
  const dispatch = useAppDispatch();

  const onSelect = () => {
    dispatch(set({value: vehicle}));
    pageCtx?.set(PAGES.RESULT);

    trackCtx?.init(
      TrackingEvents.FILTER_SELECT_CLICK,
      vehicle.model as string,
      (vehicle.model as string).toUpperCase() + '-SELECT',
      {name: (vehicle.model as string).toUpperCase() + ' : SELECT'},
      {
        type: 'single_value',
        name: (vehicle.model as string).toLowerCase() + '-select-model',
        values: [vehicle.model as string],
      },
      null,
      {
        name: (vehicle.model as string).toLowerCase() + '-process-select',
        number: 1,
        processStart: true,
      },
    );
  };

  const trans = useTrans();

  return (
    <VehicleContainer>
      <TitleContainer fontColor={vehicle.fontColor}>
        <Text
          color={TokenTextColor.inherit}
          appearance={TokenTextAppearance.headline100}
          bold
        >
          {trans['vehicles_' + vehicle.model]}
        </Text>
      </TitleContainer>
      <BackgroundContainer background={vehicle.background} />

      <ImageContainer>
        <img
          src={appCtx.imageBaseUrl + '/' + vehicle.model + '.png'}
          alt={trans['vehicles_alt_' + vehicle.model]}
        />
      </ImageContainer>

      <CTAContainer>
        <CTA
          tag="button"
          emphasis="secondary"
          stretchContent
          onClick={onSelect}
        >
          {trans.vehicles_select}
        </CTA>
      </CTAContainer>
    </VehicleContainer>
  );
};

export default VehicleComponent;
